import image1 from './vertical product shoot/1.jpg';
import image2 from './vertical product shoot/2.jpg';
import image3 from './vertical product shoot/3.jpg';
import image4 from './vertical product shoot/4.jpg';
import image5 from './vertical product shoot/5.jpg';
import image6 from './vertical product shoot/6.jpg';
import image7 from './vertical product shoot/7.jpg';
import image8 from './vertical product shoot/8.jpg';
import image9 from './vertical product shoot/9.jpg';
import image10 from './vertical product shoot/10.jpg';
import image11 from './vertical product shoot/11.jpg';
import image12 from './vertical product shoot/12.jpg';
import image13 from './vertical product shoot/13.jpg';
import image14 from './vertical product shoot/14.jpg';
import image15 from './vertical product shoot/15.jpg';
import image16 from './vertical product shoot/16.jpg';
import image17 from './vertical product shoot/17.jpg';
import image18 from './vertical product shoot/18.jpg';
import image19 from './vertical product shoot/19.jpg';
import image20 from './vertical product shoot/20.jpg';
import image21 from './vertical product shoot/21.jpg';
import image22 from './vertical product shoot/22.jpg';
import image23 from './vertical product shoot/23.jpg';
import image24 from './vertical product shoot/24.jpg';
import image25 from './vertical product shoot/25.jpg';
import image26 from './vertical product shoot/26.jpg';
import image27 from './vertical product shoot/27.jpg';
import image28 from './vertical product shoot/28.jpg';
import image29 from './vertical product shoot/29.jpg';
import image30 from './vertical product shoot/30.jpg';
import image31 from './vertical product shoot/31.jpg';
import image32 from './vertical product shoot/32.jpg';
import image33 from './vertical product shoot/33.jpg';
import image34 from './vertical product shoot/34.jpg';
import image35 from './vertical product shoot/35.jpg';
import image36 from './vertical product shoot/36.jpg';
import image37 from './vertical product shoot/37.jpg';
import image38 from './vertical product shoot/38.jpg';
import image39 from './vertical product shoot/39.jpg';
import image40 from './vertical product shoot/40.jpg';
import image41 from './vertical product shoot/41.jpg';
import image42 from './vertical product shoot/42.jpg';
import image43 from './vertical product shoot/43.jpg';
import image44 from './vertical product shoot/44.jpg';
import image45 from './vertical product shoot/45.jpg';


const productVertical = [
    image6, image7, image1, image2, image3, image4, image5,  image8, image9, image10,
  image11, image12, image13, image14, image15, image16, image17, image18, image19, image20,
  image21, image22, image23, image24, image25, image26, image27, image28, image29, image30,
  image31, image32, image33, image34, image35, image36, image37, image38, image39, image40,
  image41, image42, image43, image44
];


export default productVertical;
